// extracted by mini-css-extract-plugin
export default {"companyContainer":"XN-z","companyImage":"YN-z","container":"ZN-z","heading":"_N-z","darkText":"aO-z","smallHeading":"bO-z","darkBackground":"cO-z","whiteBackground":"dO-z"};